const LINKS_SELECTOR = '.js-add-to-calendar-link';

export default () => {
  const links = $(LINKS_SELECTOR);

  if (links.length) {
    links.on('click', (e) => {
      const $link = $(e.currentTarget);
      const modalId = $link.data('modalId');

      $('#' + modalId).modal('hide');
    })
  }
}